import * as http from 'utils/http';
import config from 'config';
import { urlToId, queryToFilters } from 'utils/converters';
import { GIS_HEADERS } from 'tenant/bussines';

const assignPayload = ({ driver, vehicle, vehicles = [] }) => ({
  driver_id: urlToId(driver),
  vehicle_id: vehicle ? urlToId(vehicle) : undefined,
  vehicle_ids: (vehicles || []).map((vehicle) => urlToId(vehicle)),
});

const fetchJourney = (id) => http.get(`${config.API_URL}mercury/journeys/${id}/`);

const assignJourney = async (journey, driver, vehicle = null, vehicles = null) => {
  await http.put(
    `${config.API_URL}mercury/journeys/${journey.id}/assign/`,
    assignPayload({ driver, vehicle, vehicles })
  );

  return await fetchJourney(journey.id);
};

const assignJourneyWithId = async (journey, driver, vehicle = null, vehicles = null) => {
  return await http.put(`${config.API_URL}mercury/journeys/${journey.id}/assign/`, {
    driver_id: driver,
    vehicle_id: vehicle || undefined,
    vehicle_ids: vehicles || undefined,
  });
};

const reassignJourney = async (journey, driver, vehicle = null, vehicles = null) => {
  await http.put(
    `${config.API_URL}mercury/journeys/${journey.id}/reassign/`,
    assignPayload({ driver, vehicle, vehicles })
  );
  return await fetchJourney(journey.id);
};

const unassignJourney = async (journeyId, params = { launch_offer: true }) => {
  await http.put(`${config.API_URL}mercury/journeys/${journeyId}/unassign/`, { ...params });

  return await fetchJourney(journeyId);
};

const advanceJourney = ({ journeyId, stop_id, stop_time }) =>
  http.put(`${config.API_URL}mercury/journeys/${journeyId}/advance/`, { stop_id, stop_time });

const launchJourney = (journey) =>
  http.put(`${config.API_URL}mercury/journeys/${journey?.id}/launch/`);

const unrejectJourney = (journey) =>
  http.put(`${config.API_URL}mercury/journeys/${journey?.id}/unreject/`);

const reviewJourney = (journey) =>
  http.post(`${config.API_URL}mercury/journeys/${journey?.id}/review/`);

const unReviewJourney = (journey) =>
  http._delete(`${config.API_URL}mercury/journeys/${journey?.id}/review/`);

const createJourney = (body) => http.post(`${config.API_URL}journeys/`, body);

const telegram = (item) => http.get(item.telegram);

const assignHandlingAgent = (journeyId, agent) => {
  return http.put(`${config.API_URL}mercury/journeys/${journeyId}/handlers/${agent.id}/`);
};

const getOperators = (input) => {
  return http.get(`${config.API_URL}staff_users/?search=${input}&page_size=0`);
};

const fetchJourneys = (
  { statuses = [], paginate = true, query, ordering = '-pickup_time_from' },
  url
) => {
  if (url) {
    return http.get(url);
  }

  const filtersStr = queryToFilters(query)
    .map((filter) =>
      Object.keys(filter)
        .map((f) => `${f}=${filter[f]}`)
        .join('&')
    )
    .join('&');

  const queryStr = statuses
    .map((status) => 'status=' + status)
    .concat(paginate ? ['page_size=50'] : ['page_size=0'])
    .concat([`ordering=${ordering}`])
    .join('&');

  return http.get(`${config.API_URL}mercury/journeys/?${queryStr}&${filtersStr}`);
};

const lastDriverPosition = (user_id) =>
  http.get(`${config.GEO_URL}gps/position/${user_id}`, null, GIS_HEADERS);

const updateStopTimes = (journey_id, journey_stop_id, timesEdited) =>
  http.patch(`${config.API_URL}mercury/journey_stops/${journey_stop_id}`, {
    journey_id,
    time_from: timesEdited.timeFrom,
    time_to: timesEdited.timeTo,
  });

export {
  assignJourney,
  assignJourneyWithId,
  reassignJourney,
  unassignJourney,
  advanceJourney,
  launchJourney,
  unrejectJourney,
  telegram,
  fetchJourney,
  fetchJourneys,
  lastDriverPosition,
  reviewJourney,
  unReviewJourney,
  createJourney,
  assignHandlingAgent,
  getOperators,
  updateStopTimes,
};
